export enum OptionsSendCodeEnum {
  sms = "sms",
  email = "email",
}